/**
 * Chart Bar component
 */
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

enum EClasses {
    sold = "sold",
    option = "option",
    request = "request",
    remaining = "remaining",
}

@Component({
    selector: 'chart-bar',
    template: `
        <div class="chart-bar"
             [ngStyle]="{'width' : width}"
             [class.is-active]="showAsActive"
             *ngIf="total !== 0">
             <ng-container *ngFor="let val of value; let i = index;">
                 <div *ngIf="val > 0"
                      class="item {{classes[i]}}"
                      [ngStyle]="{'width': percentValue[i]}">
                     {{val}}
                 </div>
             </ng-container>
        </div>
        <div class="chart-bar chart-bar-empty" *ngIf="total === 0"></div>
    `,
    styles: [`
        :host {
            display: block;
            width: 100%;
        }

        .chart-bar {
            border-radius: 4px;
            display: flex;
            overflow: hidden;
            background: #eee;
            height: 1.4em;
            line-height: 1.4em;
        }

        .chart-bar .item {
            text-align: center;
            color: white;
            display: inline-block;
        }

        .chart-bar.is-active .sold {
            background: #65b045
        }

        .chart-bar.is-active .option {
            background: #FF8F00
        }

        .chart-bar.is-active .remaining {
            background: #5bc0de
        }

        .chart-bar.is-active .request {
            background: #f4b400
        }

        .chart-bar .sold {
            background: #65b0454d
        }

        .chart-bar .option {
            background: #ff8f004d
        }

        .chart-bar .remaining {
            background: #5bc0de4d
        }

        .chart-bar .request {
            background: #f4b4004d
        }
    `]
})
export class ChartBarComponent implements OnChanges {
    @Input()
    public value: number[];
    @Input()
    public total: number;
    @Input()
    public width: string = "100%";
    @Input()
    public showAsActive: boolean = true;

    public percentValue: string[] = [];

    public classes: EClasses[] = [
        EClasses.sold,
        EClasses.option,
        EClasses.remaining,
    ];


    public ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.value && changes.value.currentValue) {
            if (this.value.length === 4) {
                this.classes = [
                    EClasses.sold,
                    EClasses.option,
                    EClasses.request,
                    EClasses.remaining,
                ];
            }
            this.percentValue = this.value.map((val: number) => `${val / this.total * 100}%`);
        }
    }
}
